// URL
export const URL_LOGIN = '/account/sign-in';
export const URL_LOGOUT = '/account/sign-out';
export const URL_REFRESH_TOKEN = `/admin-tokens/refresh-token`;
